<template>
  <div>
    <div class="main_borrow">
      <el-dialog
        class="search-result-wrapper"
        :visible.sync="dialogVisible"
        :before-close="handleDialogClose"
        :title="$t('title.popup.system.borrowArea.search')"
      >
        <el-row class="outside">
          <el-col :span="24">
            <el-form
              @submit.native.prevent
              label-width="141px"
              label-position="left"
              :rules="rules"
              :model="borrowArea"
              ref="borrowArea"
              class="zdyInput"
            >
              <!-- オーナー -->
              <el-form-item
                :label="$t('label.popup.system.borrowArea.ownerName')"
                prop="ownerName"
                class="asterisk long-name"
              >
                <div class="row">
                  <div class="edit-content heght-auto">
                    {{borrowArea.ownerName}}
                  </div>
                </div>
              </el-form-item>
              <!-- ビル -->
              <el-form-item
                :label="$t('label.popup.system.borrowArea.buildingName')"
                prop="buildingName"
                class="asterisk long-name"
              >
                <div class="row">
                  <div class="edit-content heght-auto">
                    {{borrowArea.buildingName}}
                  </div>
                </div>
              </el-form-item>
              <!-- エリア -->
              <el-form-item
                :label="$t('label.popup.system.borrowArea.areaName')"
                prop="areaName"
                class="asterisk long-name"
              >
                <div class="row">
                  <div class="edit-content heght-auto">
                    {{borrowArea.areaName}}
                  </div>
                </div>
              </el-form-item>

              <!-- 入居年月日 -->

              <el-form-item
                :label="$t('label.popup.system.borrowArea.inTime')"
                prop="startDate"
                class="asterisk"
              >
                <div class="new_date_box">
                  <el-date-picker
                    @change="changeBeginDate"
                    class="pick_date_box"
                    :placeholder="
                      $t('label.system.buildingUse.usedRoom.choice')
                    "
                    size="small"
                    type="date"
                    :clearable="false"
                    v-model="borrowArea.startDate"
                    :format="
                      'yyyy年M月d日' + ' ' + '(' + [beginCurrDay] + ')'
                    "
                    :picker-options="startDate"
                  />
                </div>
              </el-form-item>

              <!--  退居年月日  -->

              <el-form-item
                :label="$t('label.popup.system.borrowArea.outTime')"
                prop="endDate"
                class="outTime-main"
              >
                <div class="row">
                  <div class="new_date_box">
                    <el-date-picker
                      class="pick_date_box"
                      @change="changeEndDate"
                      :placeholder="
                        $t('label.system.buildingUse.usedRoom.choice')
                      "
                      size="small"
                      :clearable="false"
                      v-model="borrowArea.endDate"
                      :format="
                        'yyyy年M月d日' + ' ' + '(' + [endCurrDay] + ')'
                      "
                      type="date"
                      :picker-options="endDate"
                    />
                  </div>
                  <select-btn @click="borrowArea.endDate = null" class="fm-st-btn">
                    クリア
                  </select-btn>
                </div>
              </el-form-item>

              <!-- 借入曜日 -->
              <el-form-item
                :label="$t('label.popup.system.borrowArea.borrowWeek')"
              >
                <day
                  :day="borrowArea.borrowDayList"
                  @getDayValue="getDayValue"
                ></day>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row class="text-center">
          <narrowDown
            @click="selectBorrowArea(borrowArea)"
            class="submit_button"
          >
            {{ $t("button.common.data.setup") }}
          </narrowDown>
          <cancelNarrowDown class="link-primary" @click="handleDialogClose">
            キャンセル
          </cancelNarrowDown>
        </el-row>
      </el-dialog>
    </div>

    <owner-search-popup
      :ownerIdParam="ownerId"
      :ownerExIdParam="ownerExId"
      :ownerNameParam="ownerName"
      :visible.sync="showSelectOwnerDialog"
      @on-selected="handlerOwnerSelected">
    </owner-search-popup>
    <building-search-popup
      :ownerIdParam="ownerId"
      :ownerExIdParam="ownerExId"
      :ownerNameParam="ownerName"
      :buildingIdParam="buildingId"
      :buildingExIdParam="buildingExId"
      :buildingNameParam="buildingName"
      :visible.sync="showSelectBuildingDialog"
      @on-selected="handlerBuildSelected">
    </building-search-popup>
    <area-search-popup
      :ownerIdParam="ownerId"
      :ownerExIdParam="ownerExId"
      :ownerNameParam="ownerName"
      :buildingIdParam="buildingId"
      :buildingExIdParam="buildingExId"
      :buildingNameParam="buildingName"
      :visible.sync="showSelectAreaDialog"
      @on-selected="handlerAreaSelected">
    </area-search-popup>
    <el-dialog-prompt
      :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
      :msgParam="msgParam"
      @on-isPassParam="saveData"
    >
    </el-dialog-prompt>
  </div>
</template>

<script>
import OwnerSearchPopup from "@/components/system/popup/OwnerSearchPopup";
import BuildingSearchPopup from "@/components/system/popup/BuildingSearchPopup";
import AreaSearchPopup from "@/components/system/popup/AreaSearchPopup";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import day from "@/components/common/checkbox/WeekDaysCheckBox";
import selectBtn from "@/components/common/generalButton/Select";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import elDialogPrompt from "@/components/common/el-dialog-prompt";
import statusErrorCodeMsg from "@/utils/status-error-msg"

const weeksDay = ["日", "月", "火", "水", "木", "金", "土"];
const EVENT_ON_SELECTED = "on-selected";
export default {
  name: "BorrowAreaPopupEdit",
  components: {
    OwnerSearchPopup: OwnerSearchPopup,
    AreaSearchPopup: AreaSearchPopup,
    BuildingSearchPopup: BuildingSearchPopup,
    day: day,
    selectBtn,
    narrowDown: narrowDown,
    cancelNarrowDown: cancelNarrowDown,
    elDialogPrompt:elDialogPrompt
  },
  props: {
    visible: Boolean,
    tenantId: String,
    ownerId: String,
    ownerExId: String,
    ownerName: String,
    buildingId: String,
    buildingExId: String,
    buildingName: String,
    areaId: String,
    areaName: String,
    floorId:String,
    floorName:String,
    // time: [],
    startDate: String,
    endDate: String,
    borrowDayList: Array,
    outlookSyncFlag: Boolean
  },
  data() {
    var checkstartDate = (rule, value, callback) => {
      this.$CheckFromToDate(this.borrowArea.startDate, this.borrowArea.endDate, null, null,
        this.$t("label.popup.system.borrowArea.inTime"), this.$t("label.popup.system.borrowArea.outTime"), callback);
    };
    var checkend = () => {
      this.$refs["borrowArea"].validateField("startDate");
    };
    return {
      msgParam: this.$t("message.common.settingConfirm", {
        field: this.$t("title.popup.system.borrowArea.promptInfo"),
      }),
      centerDialogVisibleIsShow: false,
      beginCurrDay: "",
      endCurrDay: "",
      // startDate: null,
      // endDate: null,

      borrowArea: {
        tenantId: null,
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorName:null,
        floorId:null,
        areaId: null,
        areaName: null,
        startDate: null,
        endDate: null,
        borrowDayList: [],
      },
      // times: {
      //   startDate: null,
      //   endDate: null,
      // },
      dialogVisible: this.visible,
      showSelectOwnerDialog: false,
      showSelectBuildingDialog: false,
      showSelectAreaDialog: false,
      // 校验规则
      rules: {
        ownerName: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.popup.system.borrowArea.ownerName"),
            }),
          },
        ],
        buildingName: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.popup.system.borrowArea.buildingName"),
            }),
          },
        ],
        areaName: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.popup.system.borrowArea.areaName"),
            }),
          },
        ],
        startDate: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.popup.system.borrowArea.inTime"),
            }),
          },
          { validator: checkstartDate, trigger: "change" },
        ],
        endDate: [{ validator: checkend, trigger: "change" }],
      },
    };
  },
  watch: {
    visible: function (value) {
      this.dialogVisible = value;
      this.borrowArea.tenantId = this.tenantId;
      this.borrowArea.ownerId = this.ownerId;
      this.borrowArea.ownerExId = this.ownerExId;
      this.borrowArea.ownerName = this.ownerName;
      this.borrowArea.buildingId = this.buildingId;
      this.borrowArea.buildingExId = this.buildingExId;
      this.borrowArea.buildingName = this.buildingName;
      this.borrowArea.floorName = this.floorName;
      this.borrowArea.floorId = this.floorId;
      this.borrowArea.areaId = this.areaId;
      this.borrowArea.areaName = this.areaName;
      this.borrowArea.startDate = this.startDate;
      this.beginCurrDay = weeksDay[new Date(this.startDate).getDay()];
      this.borrowArea.endDate = this.endDate;
      this.endCurrDay = weeksDay[new Date(this.endDate).getDay()];
      this.borrowArea.borrowDayList = this.borrowDayList;
    },
  },
  methods: {
    getDayValue(val) {
      this.borrowArea.borrowDayList = val;
    },

    selectOwner: function () {
      this.showSelectOwnerDialog = true;
      this.borrowArea.buildingName = null;
      this.borrowArea.areaName = null;
      this.borrowArea.buildingId = null;
      this.borrowArea.buildingExId = null;
      this.borrowArea.areaId = null;
    },
    selectBuilding: function () {
      this.showSelectBuildingDialog = true;
      this.borrowArea.areaId = null;
      this.borrowArea.areaName = null;
    },
    selectArea: function () {
      this.showSelectAreaDialog = true;
    },
    handlerOwnerSelected: function (owner) {
      this.borrowArea.ownerName = owner.name;
      this.borrowArea.ownerId = owner.id;
      this.borrowArea.ownerExId = owner.exId;
      this.borrowArea.tenantId = owner.tenantId;
    },
    handlerBuildSelected: function (build) {
      this.borrowArea.ownerName = build.ownerName;
      this.borrowArea.ownerId = build.ownerId;
      this.borrowArea.buildingId = build.buildingId;
      this.borrowArea.buildingName = build.buildingName;
      this.borrowArea.buildingExId = build.buildingExId;
    },
    handlerAreaSelected: function (area) {
      this.borrowArea.ownerExId = area.ownerExId;
      this.borrowArea.buildingExId = area.buildingExId;
      this.borrowArea.buildingName = area.buildingName;
      this.borrowArea.buildingId = area.buildingId;
      this.borrowArea.ownerName = area.ownerName;
      this.borrowArea.ownerId = area.ownerId;
      this.borrowArea.areaId = area.areaId;
      this.borrowArea.areaName = area.areaName;
    },
    saveSuccess() {
      this.$messageIotSuccess(this.$t("message.common.settingSuccess", {
        field: this.$t("title.popup.system.borrowArea.promptInfo"),
      }));
    },
    selectBorrowArea: function () {
      var rule = this.rules.endDate[0];
      this.rules.endDate.pop(0);
      this.$refs["borrowArea"].validate((valid) => {
        this.rules.endDate.push(rule);
        if (!this.borrowArea.endDate) {
          this.borrowArea.startDate = this.formatTime(
            this.borrowArea.startDate,
            "yyyy/MM/dd"
          );
          this.borrowArea.endDate = "";
        } else {
          this.borrowArea.startDate = this.formatTime(
            this.borrowArea.startDate,
            "yyyy/MM/dd"
          );
          this.borrowArea.endDate = this.formatTime(
            this.borrowArea.endDate,
            "yyyy/MM/dd"
          );
        }
        if (valid) {
          this.borrowArea.tenantId = this.tenantId;
          if (this.outlookSyncFlag && this.shouldReturnTrue(this.borrowArea)) {
            let query = {
              orgId: this.borrowArea.tenantId,
              buildingId: this.borrowArea.buildingId,
              floorId: this.borrowArea.floorId,
              areaId: this.borrowArea.areaId,
            }
            this.OutlookSelfCreateFacilitySearch(query);
          }  else {
            this.msgParam = this.$t("message.common.settingConfirm", {
              field: this.$t("title.popup.system.borrowArea.promptInfo"),
            })
          }


          this.centerDialogVisibleIsShow = true;
        }
      });

    },
    OutlookSelfCreateFacilitySearch(query) {
      SystemManageApi.OutlookSelfCreateFacilitySearch(query)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({data}) => {
          let body = data?.body || {};
          const hasValue = Object.values(body).some(
            v => v !== null && v !== undefined && v !== ''
          );
          if (hasValue) {
            this.msgParam = this.$t("message.common.validation.WARN_AREA_MOVE_CHANGE_MSG");
          } else {
            this.msgParam = this.$t("message.common.settingConfirm", {
              field: this.$t("title.popup.system.borrowArea.promptInfo"),
            })
          }
        })
        .finally(() => {
        });
    },
    shouldReturnTrue(borrowArea) {
      const { startDate, endDate, borrowDayList } = borrowArea;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const start = new Date(startDate.replace(/\//g, '-'));
      const end = endDate
        ? new Date(endDate.replace(/\//g, '-'))
        : null;

      start.setHours(0, 0, 0, 0);
      if (end) end.setHours(0, 0, 0, 0);

      // ① 开始时间在系统日之后
      if (start > today) {
        return true;
      }

      // ② 终了时间在系统日之前（endDate 不为空）
      if (end && end < today) {
        return true;
      }

      // ③ 借入曜日在借入期间不存在
      // borrowDayList 为空 = 全选 → 一定存在
      if (borrowDayList.length === 0) {
        return false;
      }

      const checkEnd = end || today;
      let hasValidDay = false;

      for (
        let d = new Date(start);
        d <= checkEnd;
        d.setDate(d.getDate() + 1)
      ) {
        const weekDay = d.getDay(); // 0~6
        if (borrowDayList.includes(weekDay)) {
          hasValidDay = true;
          break;
        }
      }

      if (!hasValidDay) {
        return true;
      }

      return false;
    },

    saveData() {
      let req = {
        tenantId: this.tenantId,
        areaId: this.borrowArea.areaId,
        moveInDate: this.formatSubsmitDate(this.borrowArea.startDate),
        moveOutDate: this.formatSubsmitDate(this.borrowArea.endDate),
        dayList: this.borrowArea.borrowDayList,
      };
      SystemManageApi.tenantAreaRelationUpdate(req)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if (!statusErrorCodeMsg(data.statusCode, this, 'BorrowArea')) {
          return;
        }
        this.$emit(EVENT_ON_SELECTED, this.borrowArea);
        this.dialogVisible = false;
        this.$emit("update:visible", false);
        this.clearSearchParams();
        this.saveSuccess()
        });
    },

    formatSubsmitDate(val) {
      return new Date(val);
    },
    formatTime(date, fmt) {
      if (typeof date == "string") {
        date = new Date(date);
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    },
    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },
    handleDialogClose: function () {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.clearSearchParams();
    },
    clearSearchParams: function () {
      this.borrowArea.ownerName = null;
      this.borrowArea.buildingName = null;
      this.borrowArea.areaName = null;
      this.borrowArea.startDate = "";
      this.borrowArea.endDate = "";
      this.borrowArea.ownerId = null;
      this.borrowArea.buildingId = null;
      this.borrowArea.buildingExId = null;
      this.borrowArea.ownerExId = null;
      this.borrowArea.floorName = null;
      this.borrowArea.floorId = null;
      this.borrowArea.areaId = null;
      this.borrowArea.borrowDayList = [];
      this.$refs["borrowArea"].resetFields();
    },
    changeBeginDate(val) {
      this.beginCurrDay = weeksDay[val.getDay()];
    },
    changeEndDate(val) {
      this.endCurrDay = weeksDay[val.getDay()];
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .new-input-style {
  width: 324px;
  .el-input__inner{
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.select {
  width: 250px;
  border: 3px solid #2699fb;
  height: 40px;
  line-height: 34px;
  text-align: center;
  padding: 0;
  padding-left: 10px;
  color: #2699fb;
  font-weight: bold;
  margin-left: 316px;
}
.outside {
  display: inline-block;
}
.title {
  margin-left: 98px;
  font-size: 30px;
  font-weight: bold;
  color: #7f7f7f;
}
// 修改当前popup内部样式
.main_borrow {
  ::v-deep.el-dialog__header .el-dialog__headerbtn {
    display: none; // 不展示顶部关闭按钮
  }
}
.main_borrow {
  ::v-deep.el-dialog {
    width: 695px;
  }
}

.main_borrow {
  ::v-deep.el-dialog__body {
    padding-top: 0;
    // padding-left: 76px;
    padding-bottom: 0;
  }
}
.main_borrow {
  ::v-deep .el-dialog__header .el-dialog__headerbtn .el-icon-close {
    font-size: 16px;
    margin-left: 0;
  }
}
.main_borrow {
  ::v-deep .el-dialog__headerbtn {
    top: 26px;
  }
}
.pick_date_box {
  border-radius: 5px;
  width: 180px !important;
  height: 40px !important;
  border: none !important;
  background-color: #f2f2ed;
  float: left;
  ::v-deep .el-icon-date:before {
    display: none;
  }
  ::v-deep .el-icon-date:after {
    display: none;
  }
  ::v-deep.el-input__inner {
    border: none;
    height: 40px;
    border-radius: 4px !important;
    background-color: #f2f2ed;
    padding-left: 10px !important;
    // box-shadow: -2px -2px 5px #ffffff , -2px -2px 5px #ffffff ,
    // 4px 5px 5px #E6E6E1 , 4px 5px 5px #E6E6E1 ;
    box-shadow: -3px -2px 2px #ffffff, 3px 3px 2px #e6e6e1;
  }
}

.img-size {
  position: relative;
  left: -25px;
  top: 6px;
  -webkit-pointer-events: none;
  -moz-pointer-events: none;
  -ms-pointer-events: none;
  -o-pointer-events: none;
  pointer-events: none;
}
.new_date_box {
  width: 190px;
  height: 40px;
  border-radius: 4px;
  ::v-deep.el-input--prefix {
    .el-input__inner {
      padding-left: 9px;
    }
  }
}
.label {
  color: #2699fb;
  font-size: 14px;
}

.fm-st-btn {
  margin-left: 7px;
}
.fm-st-btn ::v-deep button {
  width: 68px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 7px;
}

.el-form-item{
  height: 65px;
}
.submit_button {
  margin-bottom: 20px;
}
// 去除formitem紅色星號，且不影響子組件
.zdyInput {
  ::v-deep.el-form-item__label::before{
    display: none;
  }
}
.el-form{
  .el-form-item {
    margin-bottom: 0px;
  }
}
.outTime-main {
  ::v-deep .el-form-item__content {
    height: 70%;
  }
}

::v-deep .el-form-item__error {
  margin-top: -16px !important;
  padding-top: 0 !important;
}
::v-deep .asterisk {
  .el-form-item__label::after{
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
}
.edit-content {
  height: 40px;
}
.long-name {
  height:auto;
  width:550px;
  padding-bottom:25px;
}
.heght-auto{
  height:auto;
}
</style>
